export class FetchGradingSchemeByModuleIdDone {
    static readonly type = '[GradingScheme] FetchGradingSchemeByModuleIdDone';
}
